<template>
  <div>
    <div ref="popupNewDay" class="overlay d-none">
      <div class="content bg-white rounded border shadow p-3 position-relative container">
        <div class="position-absolute" style="right: 25px; cursor: pointer;" @click="closePopupNewDay">
          <i class="fa fa-times" aria-hidden="true"></i>
        </div>
        <h5>{{ fechasDisponibles.includes(daySelected) ? 'Editar' : 'Nuevo' }} Día de Reserva</h5>
        <hr />
        <!-- New Day Fecha-->
        <div>
          <input type="date" class="form-control w-fit-content mx-auto" v-model="newDay.fecha" />
          <label for="cambiaDefault" class="me-2"
            title="Estando habilitado, cuando el precio default cambie, se cambiarán en este día">
            Actualizar precios automáticamente cuando cambien los precios por defecto
          </label>
          <input type="checkbox" v-model="newDay.cambiaDefault" true-value="1" false-value="0"/>
        </div>
        <hr />
        <label>Acceso al Cerro</label>
        <input class="form-control" style="width: 250px;" v-model="newDay.accesoCerro"/>
        <hr />
        <!-- New Day Detalle -->
        <div class="row">
          <div class="col">
            <label for="newDay1" class="me-1 text-nowrap">Habitación 1</label><br />
            <input type="checkbox" v-model="newDay.complejo1" id="newDay1" true-value="1" false-value="0"/>
            <div v-if="newDay.complejo1 == 1" class="input-group mb-3">
              <span class="input-group-text" id="basic-addon1">$</span>
              <input type="number" step="1" class="form-control" aria-describedby="basic-addon1"
                v-model="newDay.monto1" />
            </div>
            <div v-if="newDay.complejo1 == 1" class="input-group mb-3">
              <span class="input-group-text" id="basic-addon2"><i class="fa fa-male" aria-hidden="true"></i>
              </span>
              <input type="number" step="1" class="form-control" aria-describedby="basic-addon2"
                v-model="newDay.cantidad1" />
            </div>
          </div>
          <div class="col" style="border-left: #CACFD3 1px solid;">
            <label for="newDay2" class="me-1 text-nowrap">Habitación 2</label><br />
            <input type="checkbox" v-model="newDay.complejo2" id="newDay2" true-value="1" false-value="0"/>
            <div v-if="newDay.complejo2 == 1" class="input-group mb-3">
              <span class="input-group-text" id="basic-addon3">$</span>
              <input type="number" step="1" class="form-control" aria-describedby="basic-addon3"
                v-model="newDay.monto2" />
            </div>
            <div v-if="newDay.complejo2 == 1" class="input-group mb-3">
              <span class="input-group-text" id="basic-addon4"><i class="fa fa-male" aria-hidden="true"></i>
              </span>
              <input type="number" step="1" class="form-control" aria-describedby="basic-addon4"
                v-model="newDay.cantidad2" />
            </div>
          </div>
          <div class="col" style="border-left: #CACFD3 1px solid;">
            <label for="newDay3" class="me-1 text-nowrap">Habitación 3</label><br />
            <input type="checkbox" v-model="newDay.complejo3" id="newDay3" true-value="1" false-value="0"/>
            <div v-if="newDay.complejo3 == 1" class="input-group mb-3">
              <span class="input-group-text" id="basic-addon5">$</span>
              <input type="number" step="1" class="form-control" aria-describedby="basic-addon5"
                v-model="newDay.monto3" />
            </div>
            <div v-if="newDay.complejo3 == 1" class="input-group mb-3">
              <span class="input-group-text" id="basic-addon6"><i class="fa fa-male" aria-hidden="true"></i>
              </span>
              <input type="number" step="1" class="form-control" aria-describedby="basic-addon6"
                v-model="newDay.cantidad3" />
            </div>
          </div>
          <div class="col" style="border-left: #CACFD3 1px solid;">
            <label for="newDay4" class="me-1 text-nowrap">Habitación 4</label><br />
            <input type="checkbox" v-model="newDay.complejo4" id="newDay4" true-value="1" false-value="0"/>
            <div v-if="newDay.complejo4 == 1" class="input-group mb-3">
              <span class="input-group-text" id="basic-addon7">$</span>
              <input type="number" step="1" class="form-control" aria-describedby="basic-addon7"
                v-model="newDay.monto4" />
            </div>
            <div v-if="newDay.complejo4 == 1" class="input-group mb-3">
              <span class="input-group-text" id="basic-addon8"><i class="fa fa-male" aria-hidden="true"></i>
              </span>
              <input type="number" step="1" class="form-control" aria-describedby="basic-addon8"
                v-model="newDay.cantidad4" />
            </div>
          </div>
          <div class="col" style="border-left: #CACFD3 1px solid;">
            <label for="newDayAcampe" class="me-1">Acampe</label><br />
            <input type="checkbox" v-model="newDay.acampe" id="newDayAcampe" true-value="1" false-value="0"/>
            <div v-if="newDay.acampe == 1" class="input-group mb-3">
              <span class="input-group-text" id="basic-addon9">$</span>
              <input type="number" step="1" class="form-control" aria-describedby="basic-addon9"
                v-model="newDay.montoAcampe" />
            </div>
            <div v-if="newDay.acampe == 1" class="input-group mb-3">
              <span class="input-group-text" id="basic-addon10"><i class="fa fa-male" aria-hidden="true"></i>
              </span>
              <input type="number" step="1" class="form-control" aria-describedby="basic-addon10"
                v-model="newDay.cantidadAcampe" />
            </div>
          </div>
        </div>
        <hr />
        <!-- New Day Buttons-->
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-success" @click="diaHabilitadoUpdateStore">Guardar</button>
        </div>
      </div>
    </div>

    <div class="pb-4">
      <h2 class="text-center shadow-sm border py-2 mx-2">Fechas</h2>
      <div class="" style="min-height: calc(100% - 85px);">
        <ComponentCalendarAdmin :fechasDisponibles="fechasDisponibles" @toggle-day="handleDayClick" />
      </div>
      <div class="d-flex justify-content-start ms-2">
        <button type="button" class="btn btn-success"
          @click="() => { this.newDay.id = null; this.newDay.fecha = null; this.openPopupNewDay(true); }">Nuevo día de
          Reserva</button>
      </div>
      
      <table class="table striped mt-4 table-bordered">
        <tbody>
          <tr>
            <td></td>
            <td colspan="2">Habitación 1</td>
            <td colspan="2">Habitación 2</td>
            <td colspan="2">Habitación 3</td>
            <td colspan="2">Habitación 4</td>
            <td colspan="2">Acampe</td>
            <th></th>
          </tr>
          <template v-for="fechaDisponible in fechasDisponiblesDetalle" :key="fechaDisponible.id">
            <tr :title="(!fechaDisponible.habilitado ? 'Fecha Cancelada' : '')">
              <td :class="'text-center '+(!fechaDisponible.habilitado ? 'table-danger' : 'table-dark')">
                {{ fechaDisponible.fecha.split('-').reverse().join('/') }}
                <i :class="'fa fa-refresh ' + (fechaDisponible.cambiaDefault ? 'text-success' : 'text-danger')"
                  aria-hidden="true"
                  :title="(fechaDisponible.cambiaDefault ? 'Actualizar' : 'No actualizar') + ' precios automáticamente cuando cambien los precios por defecto'"></i>
              </td>
              <td>${{ fechaDisponible.monto1.toLocaleString() }}</td>
              <td><i class="fa fa-male" aria-hidden="true"></i> {{ fechaDisponible.cantidad1 }}</td>
              <td>${{ fechaDisponible.monto2.toLocaleString() }}</td>
              <td><i class="fa fa-male" aria-hidden="true"></i> {{ fechaDisponible.cantidad2 }}</td>
              <td>${{ fechaDisponible.monto3.toLocaleString() }}</td>
              <td><i class="fa fa-male" aria-hidden="true"></i> {{ fechaDisponible.cantidad3 }}</td>
              <td>${{ fechaDisponible.monto4.toLocaleString() }}</td>
              <td><i class="fa fa-male" aria-hidden="true"></i> {{ fechaDisponible.cantidad4 }}</td>
              <td>${{ fechaDisponible.montoAcampe.toLocaleString() }}</td>
              <td><i class="fa fa-male" aria-hidden="true"></i> {{ fechaDisponible.cantidadAcampe }}</td>
              <td>
                <i v-if="fechaDisponible.habilitado" class="fa-solid fa-trash-can" @click="diaHabilitadoDelete(fechaDisponible.id)" style="cursor: pointer; color: red;"></i>
                <i v-else class="fa-solid fa-rotate-left" @click="diaHabilitadoRestore(fechaDisponible.id)" style="cursor: pointer; color: green;"></i>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ComponentCalendarAdmin from '../components/admin/ComponentCalendarAdmin.vue';
import { useToast } from "vue-toastification";
import { nextTick } from 'vue';
const toast = useToast();

export default {
  name: 'ViewAdminFechas',
  components: {
    ComponentCalendarAdmin
  },
  data() {
    return {
      fechasDisponibles: [],
      fechasDisponiblesDetalle: [],
      diaSeleccionado: {
        fecha: null,
        complejo1: false,
        complejo2: false,
        complejo3: false,
        complejo4: false,
        acampe: false
      },
      newDay: {
        id: null,
        fecha: null,
        complejo1: 1,
        monto1: null,
        cantidad1: null,
        complejo2: 1,
        monto2: null,
        cantidad2: null,
        complejo3: 1,
        monto3: null,
        cantidad3: null,
        complejo4: 1,
        monto4: null,
        cantidad4: null,
        acampe: 1,
        montoAcampe: null,
        cantidadAcampe: null,
        cambiaDefault: 1,
        accesoCerro: null
      },
      precios: {},
      daySelected: null
    };
  },
  mounted() {
    this.precioGet();
    this.diaHabilitadoGetAll();
  },
  methods: {
    ...mapActions('diaHabilitado', ['diaHabilitado_getAll', 'diaHabilitado_updateStore', 'diaHabilitado_delete', 'diaHabilitado_restore']),
    ...mapActions('precio', ['precio_get']),
    async precioGet() {
      try {
        let response = await this.precio_get();

        if (response.status == 200) {
          this.precios = response.data;

          this.newDay.monto1 = this.precios.complejo1.monto;
          this.newDay.cantidad1 = this.precios.complejo1.cantidad;
          this.newDay.complejo1 = 1;

          this.newDay.monto2 = this.precios.complejo2.monto,
          this.newDay.cantidad2 = this.precios.complejo2.cantidad;
          this.newDay.complejo2 = 1;

          this.newDay.monto3 = this.precios.complejo3.monto;
          this.newDay.cantidad3 = this.precios.complejo3.cantidad;
          this.newDay.complejo3 = 1;

          this.newDay.monto4 = this.precios.complejo4.monto;
          this.newDay.cantidad4 = this.precios.complejo4.cantidad;
          this.newDay.complejo4 = 1;

          this.newDay.montoAcampe = this.precios.acampe.monto;
          this.newDay.cantidadAcampe = this.precios.acampe.cantidad;
          this.newDay.acampe = 1;
          this.newDay.accesoCerro = response.data.accesoCerro.value;
        }

      } catch (error) {
        console.log(error);
        toast.error('Error obteniendo precios');
      }
    },
    async diaHabilitadoUpdateStore() {
      try {

        this.fecha
        if (this.newDay.complejo1 && !this.newDay.monto1) {
          toast.error('Debe indicar el monto de la Habitación 1');
          return;
        }
        if (this.newDay.complejo1 && !this.newDay.cantidad1) {
          toast.error('La cantidad de la Habitación 1 debe ser mayor a cero');
          return;
        }

        if (this.newDay.complejo2 && !this.newDay.monto2) {
          toast.error('Debe indicar el monto de la Habitación 2');
          return;
        }
        if (this.newDay.complejo2 && !this.newDay.cantidad2) {
          toast.error('La cantidad de la Habitación 2 debe ser mayor a cero');
          return;
        }

        if (this.newDay.complejo3 && !this.newDay.monto3) {
          toast.error('Debe indicar el monto de la Habitación 3');
          return;
        }
        if (this.newDay.complejo3 && !this.newDay.cantidad3) {
          toast.error('La cantidad de la Habitación 3 debe ser mayor a cero');
          return;
        }

        if (this.newDay.complejo4 && !this.newDay.monto4) {
          toast.error('Debe indicar el monto de la Habitación 4');
          return;
        }
        if (this.newDay.complejo4 && !this.newDay.cantidad4) {
          toast.error('La cantidad de la Habitación 4 debe ser mayor a cero');
          return;
        }

        if (this.newDay.acampe && !this.newDay.montoAcampe) {
          toast.error('Debe indicar el monto del Acampe');
          return;
        }
        if (this.newDay.acampe && !this.newDay.cantidadAcampe) {
          toast.error('La cantidad del Acampe debe ser mayor a cero');
          return;
        }

        let response = await this.diaHabilitado_updateStore(this.newDay);

        if (response.status == 200) {
          toast.success('Día de reserva creado con éxito');
          //window.location.reload();
        }

        this.closePopupNewDay();
        this.diaHabilitadoGetAll();
      } catch (error) {
        console.log(error);
        toast.error('Error al guardar la reserva');
        this.closePopupNewDay();
      }
    },
    async handleDayClick(daySelected) {
      console.log('daySelected:', daySelected);
      this.daySelected = daySelected;
      this.newDay.fecha = this.daySelected;
      let indexFechaDisponible = this.fechasDisponibles.indexOf(daySelected);

      console.log('daySelected: ', daySelected);
      console.log('indexFechaDisponible: ',indexFechaDisponible);

      if (indexFechaDisponible != -1) {
        
        const found = this.fechasDisponiblesDetalle.find(
          el => el.fecha === daySelected
        );

        this.newDay = Object.assign({}, found);

        console.log('this.newDay: ',this.newDay);

        await nextTick();
        this.openPopupNewDay(found.cambiaDefault);
      } else {
        await this.precioGet();
        this.openPopupNewDay(1);
      }


    },
    closePopupNewDay() {
      this.$refs.popupNewDay.classList.add('d-none');
    },
    async openPopupNewDay(cambiaDefault) {
      this.newDay.cambiaDefault = cambiaDefault;
      this.$refs.popupNewDay.classList.remove('d-none');
    },
    async diaHabilitadoGetAll() {
      try {
        let response = await this.diaHabilitado_getAll();

        if (response.status == 200) {

          console.log('response.data.diasHabilitadosv: ',response.data.diasHabilitados);
          //this.fechasDisponiblesDetalle = response.data.diasHabilitados.filter(el => el.habilitado == 1);
          this.fechasDisponiblesDetalle = response.data.diasHabilitados;
          console.log('this.fechasDisponiblesDetalle: ',this.fechasDisponiblesDetalle);
          this.fechasDisponibles = [];

          this.fechasDisponiblesDetalle.forEach(fechaDisponible => {
            this.fechasDisponibles.push(fechaDisponible.fecha);
          });

        }
      } catch (error) {
        console.log(error);
        toast.error('Error obteniendo dias habilitados');
      }
    },
    async diaHabilitadoDelete(id) {
      try {
        let response = await this.diaHabilitado_delete({id: id});

        if (response.status == 200) {
          toast.success('Fecha eliminada con éxito');
          this.diaHabilitadoGetAll();
        }

      } catch (error) {
        console.log(error);
        toast.error('Error elminando fecha');
      }
    },
    async diaHabilitadoRestore(id) {
      try {
        let response = await this.diaHabilitado_restore({id: id});

        if (response.status == 200) {
          toast.success('Fecha restaurada con éxito');
          this.diaHabilitadoGetAll();
        }

      } catch (error) {
        console.log(error);
        toast.error('Error elminando fecha');
      }
    }
  },

};
</script>

<style scoped>
.overlay {
  position: fixed;
  /* Se mantiene en su lugar al hacer scroll */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* Fondo negro con 50% de opacidad */
  z-index: 1000;
  /* Asegura que esté por encima de otros elementos */
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
